import { Map } from "immutable";

import queryActionTypes from "../../../action-types";
import { AggregationsState } from "../../../models/CoursesQuery";

type CategoryAggregationsType = {
  buckets: Array<{
    key: string;
    doc_count: number;
  }>;
};

type FilteredType = {
  filtered: CategoryAggregationsType;
};

type AggregationsType = {
  aggregations: {
    all: Record<string, FilteredType>;
  };
};

export function makeReducer(actionTypes: typeof queryActionTypes) {
  function aggregationsReducer(
    state: AggregationsState,
    action: {
      type: string;
      payload: AggregationsType;
    }
  ) {
    if (action.type === actionTypes.RECEIVE_QUERY_RESULTS) {
      const { aggregations } = action.payload;
      const categories = aggregations && Object.values(aggregations.all);
      const newState = Map();
      if (!categories) return state;

      return newState.withMutations(newState => {
        categories.forEach(category => {
          if (category.filtered && category.filtered.buckets) {
            category.filtered.buckets.forEach(bucket => {
              newState.set(bucket.key, bucket.doc_count);
            });
          }
        });
      });
    }

    return state;
  }

  return aggregationsReducer;
}

export default makeReducer(queryActionTypes);
